import type { Usage } from "./types";

export function formatQuota(value: number | undefined | null): string {
  const n = Number(value || 0);
  if (n >= 100_000_000) return (n / 100_000_000).toFixed(2) + " 亿";
  if (n >= 10_000) return (n / 10_000).toFixed(2) + " 万";
  return new Intl.NumberFormat("zh-CN").format(n);
}

export function formatMoney(value: number | undefined | null): string {
  return new Intl.NumberFormat("zh-CN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

export function formatExpires(usage: Usage | undefined | null): string {
  if (!usage || !usage.expires_at) return "长期有效";
  const date = usage.expires_at_iso
    ? new Date(usage.expires_at_iso)
    : new Date(Number(usage.expires_at) * 1000);
  if (Number.isNaN(date.getTime())) return "长期有效";
  return date.toLocaleString("zh-CN", { hour12: false });
}

// Server returns a single OpenAI-shaped base URL (e.g. ".../v1") because
// codex/cursor/OpenAI SDK clients hit it as-is. The Anthropic SDK appends
// "/v1/messages" to ANTHROPIC_BASE_URL itself, so claude callers must use
// the same host *without* the trailing "/v1" — otherwise requests land on
// "/v1/v1/messages" and the relay returns 404.
export function deriveBaseURLs(baseURL: string | undefined | null): { openai: string; anthropic: string } {
  const trimmed = String(baseURL || "").replace(/\/+$/, "");
  if (!trimmed) return { openai: "", anthropic: "" };
  return { openai: trimmed, anthropic: trimmed.replace(/\/v1$/, "") };
}
